export const systemTagMapping = {
  'system-whatsapp': 'WhatsApp',
  'system-instagram': 'Instagram',
};
